export const moneyFormatter = new Intl.NumberFormat('sk-SK', {
  style: 'currency',
  currency: 'EUR',

  // These options are needed to round to whole numbers if that's what you want.
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/**
 * Pozor:
 * Naformátuje číslo 0.5 ako 50.0000%, číslo 50 ako 5000.0000%.
 */
export const percentageFormatter4Digits = new Intl.NumberFormat('sk-SK', {
  style: 'percent',
  minimumFractionDigits: 4,
  maximumFractionDigits: 4,
});

/**
 * Pozor:
 * Naformátuje číslo 0.5 ako 50%, číslo 50 ako 5000%.
 */
export const percentageFormatter = new Intl.NumberFormat('sk-SK', {
  style: 'percent',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

/**
 * Vezme hodnotu ktora reprezentuje percenta a sformatuje ju pre SK lokalizaciu.
 * @param percent Cislo, ktore chceme sformatovat.
 * @param decimals Pocet desatinnych miest.
 */
export const formatPercentage = (percent: number, decimals: 0 | 4 = 0) => {
  if (decimals == 4) {
    return percentageFormatter4Digits.format(percent / 100)
  }
  return percentageFormatter.format(percent / 100)
}

export const formatMoney = (value: number) => moneyFormatter.format(value)
